<img [src]="url | safe: 'resourceUrl'" alt="pixel" class="pixel">
